export const LOADING_MESSAGES = {
    SEARCH: "Buscando...",
    UPDATE: "Reasignando asesoría..."
}